import React, { useState, useEffect, Fragment } from "react";
import styled from "styled-components";
import MediaQuery from "react-responsive";
import DoubleQuotes from "../../../../public/images/homepage/icons/double-quotes.svg";
import { textTranslation, shouldTranslateTo } from "../utils/utils";

const Container = styled.div`
    position: relative;

    @media screen and (max-width: 768px) {
        width: 100%;
    }
`;

const CarouselWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

const ArrowButton = styled.button`
    background-color: #154549;
    border-radius: 50px;
    width: 50px;
    height: 50px;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
`;

const CarouselImageWrapper = styled.div`
    margin: 0 10px;
    transition: all 0.5s ease-in-out;
`;

const ArrowIcon = styled.img`
    width: 12px;
    rotate: ${({ iconRotate }) => (iconRotate ? "180deg" : "0deg")};
`;

const TestimonialsCarouselDiv = styled.div`
    display: flex;
    /* background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(0,0,0,1) 50%, rgba(255,255,255,1) 100%); */
`;

const TestimonialsCarouselItem = styled.div`
    width: 25vw;
    height: 100%;
    border-radius: 15px;
    opacity: 0.96;
    background-color: #fff;
    padding: 18px 30px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (max-width: 768px) {
        width: 70vw;
        padding: 18px 20px;
    }
`;

const DoubleQuotesImg = styled.img`
    width: 50px;
    margin-bottom: 23px;
`;

const Text = styled.h5`
    color: #000;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 143%;
    height: fit-content;
    margin-bottom: 10px;

    @media screen and (max-width: 1025px) {
        height: 200px;
    }

    @media screen and (max-width: 768px) {
        height: 200px;
    }
`;

const Name = styled.h5`
    color: #16494d;
    font-family: "Open Sans", sans-serif;
    font-size: 25px;
    font-weight: 700;
    line-height: 140%;
`;

const Country = styled.h5`
    color: #000;
    font-family: "Open Sans", sans-serif;
    font-size: 17px;
    font-weight: 400;
    line-height: 140%;
`;

const ResponsiveArrows = styled.div`
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 100px;
`;

const FlagDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    img {
        width: 30px;
        height: 20px;
        margin-right: 10px;
    }
`;

const CurrentInfo = styled.div`
    text-align: end;
    padding-right: 60px;

    h5 {
        font-size: 18px;
        font-family: "Open Sans", sans-serif !important;
    }
`;

const TestimonialsCarousel = ({}) => {
    const [currentIndex, setCurrentIndex] = useState(2);

    const [pageText, setPageText] = React.useState([]);
    const [testimonials, setTestimonials] = React.useState([]);

    React.useEffect(() => {
        const language = shouldTranslateTo();
        const getPageText = (pageValue, languageValue) => {
            axios
                .get(`/api/page-text/${pageValue}/${languageValue}`)
                .then(response => {
                    const testimonialsRaw = response.data.map(item =>
                        JSON.parse(item.text)
                    );
                    setTestimonials(testimonialsRaw);
                })
                .catch(err => {
                    console.log("Error getting page text: ", err);
                });
        };

        getPageText("homepage-testimonial", language);
    }, []);

    const handlePrevious = () => {
        const newIndex =
            currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const handleNext = () => {
        const newIndex = (currentIndex + 1) % testimonials.length;
        setCurrentIndex(newIndex);
    };

    const getTestimonialsDisplay = () => {
        const total = testimonials.length;
        let divs = [];

        for (let i = -1; i <= 1; i++) {
            let index = (currentIndex + i + total) % total;
            let flag = testimonials[index].country
                .replace(/\s+/g, "_")
                .toLowerCase();
            divs.push(
                <CarouselImageWrapper key={index}>
                    <TestimonialsCarouselItem>
                        <div>
                            <DoubleQuotesImg src={DoubleQuotes} />
                            <Text
                                dangerouslySetInnerHTML={{
                                    __html: testimonials[index].text
                                }}
                            ></Text>
                        </div>

                        <div>
                            <Name>{testimonials[index].name}</Name>
                            <FlagDiv>
                                <img
                                    src={"/images/languages/" + flag + ".svg"}
                                    alt={testimonials[index].country}
                                    className="flag"
                                />
                                <Country>{testimonials[index].country}</Country>
                            </FlagDiv>
                        </div>
                    </TestimonialsCarouselItem>
                </CarouselImageWrapper>
            );
        }
        return divs;
    };

    return (
        <div>
            {testimonials && testimonials.length > 0 ? (
                <Container>
                    <CurrentInfo>
                        {
                            <h5>
                                <b>{currentIndex + 1}</b> /{" "}
                                {testimonials.length}
                            </h5>
                        }
                    </CurrentInfo>
                    <CarouselWrapper>
                        <ArrowButton onClick={handlePrevious}>
                            <ArrowIcon
                                src="/images/homepage/icons/arrow-line.svg"
                                alt="arrow left"
                            />
                        </ArrowButton>
                        <TestimonialsCarouselDiv>
                            {getTestimonialsDisplay()}
                        </TestimonialsCarouselDiv>
                        <ArrowButton onClick={handleNext}>
                            <ArrowIcon
                                src="/images/homepage/icons/arrow-line.svg"
                                alt="arrow right"
                                iconRotate
                            />
                        </ArrowButton>
                    </CarouselWrapper>
                    <MediaQuery maxWidth={777}>
                        <ResponsiveArrows>
                            <ArrowButton onClick={handlePrevious}>
                                <ArrowIcon
                                    src="/images/homepage/icons/arrow-line.svg"
                                    alt="arrow left"
                                />
                            </ArrowButton>
                            <ArrowButton onClick={handleNext}>
                                <ArrowIcon
                                    src="/images/homepage/icons/arrow-line.svg"
                                    alt="arrow right"
                                    iconRotate
                                />
                            </ArrowButton>
                        </ResponsiveArrows>
                    </MediaQuery>
                </Container>
            ) : (
                ""
            )}
        </div>
    );
};

export default TestimonialsCarousel;
